module.exports = "<react-getting-started-progress></react-getting-started-progress>\n\n<react-benefits />\n\n";